// Module
var code = "<div>\n    <md-button aria-label=\"Import bicycles\" ng-click=\"bli.import($event)\" class=\"md-raised\" title=\"Import bicycles\">\n        <i class=\"fa fa-upload\" aria-hidden=\"true\"></i>\n        <span>Import bikes</span>\n    </md-button>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/bike/list/business/bl-import.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;